import { render, staticRenderFns } from "./StudentEditGradeSlidebar.vue?vue&type=template&id=72f89666"
import script from "./StudentEditGradeSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentEditGradeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports